import React, { useLayoutEffect, useState } from 'react';
import { Col, message, Row, Spin } from 'antd';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { LoadingOutlined } from '@ant-design/icons';

import Utils from './Assets/Scripts/Utils';
import BaseLayout from './Components/BaseLayout/BaseLayout';
import AppDownload from './Pages/App/AppDownload/AppDownload';
import AppPrivacyPolicy from './Pages/App/AppPrivacyPolicy/AppPrivacyPolicy';
import AppSupportInfo from './Pages/App/AppSupportInfo/AppSupportInfo';
import Billing from './Pages/Billing/Billing';
import CertificateView from './Pages/Certificate/CertificateView';
import CompanyList from './Pages/Company/List/CompanyList';
import CompanyRegister from './Pages/Company/Register/CompanyRegister';
import DenyTaskReasonList from './Pages/DenyTaskReason/List/DenyTaskReasonList';
import DenyTaskReasonRegister from './Pages/DenyTaskReason/Register/DenyTaskReasonRegister';
import DocumentTypeList from './Pages/DocumentType/List/DocumentTypeList';
import DocumentTypeRegister from './Pages/DocumentType/Register/DocumentTypeRegister';
import DriverList from './Pages/Driver/List/DriverList';
import DriverRegister from './Pages/Driver/Register/DriverRegister';
import ForgotPassword from './Pages/ForgotPassword/ForgotPassword';
import Home from './Pages/Home/Home';
import InstructorList from './Pages/Instructor/List/InstructorList';
import InstructorRegister from './Pages/Instructor/Register/InstructorRegister';
import InstructorManagement from './Pages/InstructorManagement/InstructorManagement';
import InstructorPreRegisterList from './Pages/InstructorPreRegister/List/InstructorPreRegisterList';
import InstructorPreRegister from './Pages/InstructorPreRegister/Register/InstructorPreRegister';
import InvoiceIssuerList from './Pages/InvoiceIssuer/List/InvoiceIssuerList';
import InvoiceIssuerRegister from './Pages/InvoiceIssuer/Register/InvoiceIssuerRegister';
import Login from './Pages/Login/Login';
import OccurrenceList from './Pages/Occurrence/List/OccurrenceList';
import OccurrenceRegister from './Pages/Occurrence/Register/OccurrenceRegister';
import OccurrenceManagementView from './Pages/OccurrenceManagement/OccurrenceManagementView';
import OccurrenceTypeList from './Pages/OccurrenceType/List/OccurrenceTypeList';
import OccurrenceTypeRegister from './Pages/OccurrenceType/Register/OccurrenceTypeRegister';
import ProductList from './Pages/Product/List/ProductList';
import ProductRegister from './Pages/Product/Register/ProductRegister';
import Profile from './Pages/Profile/Profile';
import ReasonNoBillingList from './Pages/ReasonNoBilling/List/ReasonNoBillingList';
import ReasonNoBillingRegister from './Pages/ReasonNoBilling/Register/ReasonNoBillingRegister';
import FieldCustomizationView from './Pages/Role/FieldCustomization/FieldCustomizationView';
import RoleList from './Pages/Role/List/RoleList';
import RoleRegister from './Pages/Role/Register/RoleRegister';
import ScheduleScheduling from './Pages/ScheduleConecta/ScheduleScheduling';
import ScheduleDriver from './Pages/ScheduleDriver/ScheduleDriver';
import ScheduleInstructor from './Pages/ScheduleInstructor/ScheduleInstructor';
import ScheduleOverview from './Pages/ScheduleOverview/ScheduleOverview';
import ScheduleTrainingCenter from './Pages/ScheduleTrainingCenter/ScheduleTrainingCenter';
import Settings from './Pages/Settings/Settings';
import TaskListView from './Pages/TaskList/TaskListView';
import TrainingCenterList from './Pages/TrainingCenter/List/TrainingCenterList';
import TrainingCenterRegister from './Pages/TrainingCenter/Register/TrainingCenterRegister';
import TransportList from './Pages/Transport/List/TransportList';
import TransportRegister from './Pages/Transport/Register/TransportRegister';
import UserList from './Pages/User/List/UserList';
import UserRegister from './Pages/User/Register/UserRegister';
import VehicleList from './Pages/Vehicle/List/VehicleList';
import VehicleRegister from './Pages/Vehicle/Register/VehicleRegister';
import VehicleTypeList from './Pages/VehicleType/List/VehicleTypeList';
import VehicleTypeRegister from './Pages/VehicleType/Register/VehicleTypeRegister';
import { api } from './Services/axiosService';

export default function NavigationRoutes() {
  const [permissions, setPermissions] = useState();
  const [loading, setLoading] = useState(false);

  const fetchUserAndPermissions = async () => {
    setLoading(true);
    const userData = localStorage.getItem('conecta__userData');

    if (userData) {
      const userId = JSON.parse(userData).id;

      let newUserData;
      let newRoleData;
      try {
        const userResponse = await api.get(`/User/UserAndRole?userId=${userId}`);
        newUserData = userResponse.data.userData;
        newRoleData = userResponse.data.roleData;
      } catch (error) {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os dados do Usuário e Cargo!');
      }

      if (newUserData) {
        const parsedUserData = {
          ...newUserData,
          companyId: newUserData.company?.id,
          companyName: newUserData.company?.name,
        };

        localStorage.setItem('conecta__userData', JSON.stringify(parsedUserData));
      }

      if (newRoleData) {
        localStorage.setItem('conecta__permissions', JSON.stringify(newRoleData));

        const permissions = {};
        newRoleData.resources.forEach(({ name, canView, canHandle, selfView }) => {
          permissions[name] = { canView, canHandle, selfView };
        });

        const roleId = newRoleData.id;
        permissions.id = roleId;
        if (roleId === 21 || roleId === 1) {
          permissions.ScheduleTrainingCenter = {
            canView: true,
            canHandle: permissions.ScheduleTrainingCenter?.canHandle ?? true,
            selfView: permissions.ScheduleTrainingCenter?.selfView ?? false,
          };
        }

        setPermissions(permissions);
      }
    }

    setLoading(false);
  };

  useLayoutEffect(() => {
    fetchUserAndPermissions();
  }, []);

  if (loading) {
    return (
      <Row gutter={[24]}>
        <Col
          span={24}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '72vh',
          }}
        >
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 56,
                  textAlign: 'center',
                }}
                spin
              />
            }
          />
        </Col>
      </Row>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/Instrutor" element={<InstructorPreRegister />} />
        <Route exact path="/InstrutorMobile" element={<InstructorPreRegister mobile={true} />} />
        <Route exact path="/Login" element={<Login />} />
        <Route exact path="/RecuperarSenha" element={<ForgotPassword />} />
        <Route exact path="/App/Download" element={<AppDownload />} />
        <Route exact path="/App/PoliticaPrivacidade" element={<AppPrivacyPolicy />} />
        <Route exact path="/App/Suporte" element={<AppSupportInfo />} />
        <Route exact path="/RecuperarSenhaMobile" element={<ForgotPassword mobile={true} />} />
        {Object.keys(permissions ?? {}).length === 0 && <Route path="*" element={<Login />} />}
        {Object.keys(permissions ?? {}).length > 0 && (
          <Route path="/" element={<BaseLayout />}>
            <Route exact path="/" element={<Home />} />

            {permissions.Configuration?.canView && (
              <Route exact path="/Configuracao" element={<Settings />} />
            )}

            {permissions.PreInstructor?.canView && (
              <Route exact path="/PreCadastroInstrutor" element={<InstructorPreRegisterList />} />
            )}

            {permissions.PreInstructor?.canHandle && (
              <Route
                exact
                path="/PreCadastroInstrutor/Editar/:id"
                element={<InstructorPreRegister />}
              />
            )}

            {permissions.Profile?.canView && <Route exact path="/Perfil" element={<Profile />} />}

            {permissions.User?.canView && (
              <Route exact path="/Usuario/Listar" element={<UserList />} />
            )}

            {permissions.User?.canHandle && (
              <Route exact path="/Usuario/Cadastrar" element={<UserRegister />} />
            )}

            {permissions.User?.canHandle && (
              <Route exact path="/Usuario/Editar/:id" element={<UserRegister />} />
            )}

            {permissions.Role?.canView && (
              <Route exact path="/Cargo/Listar" element={<RoleList />} />
            )}

            {permissions.Role?.canHandle && (
              <Route exact path="/Cargo/Cadastrar" element={<RoleRegister />} />
            )}

            {permissions.Role?.canHandle && (
              <Route exact path="/Cargo/Editar/:id" element={<RoleRegister />} />
            )}

            {permissions.id === 21 && (
              <Route
                exact
                path="/Cargo/Customizacao/:resourceId"
                element={<FieldCustomizationView />}
              />
            )}

            {permissions.TrainingCenter?.canView && (
              <Route exact path="/CentroTreinamento/Listar" element={<TrainingCenterList />} />
            )}

            {permissions.TrainingCenter?.canHandle && (
              <Route
                exact
                path="/CentroTreinamento/Cadastrar"
                element={<TrainingCenterRegister />}
              />
            )}

            {(permissions.TrainingCenter?.canHandle || permissions.TrainingCenter?.selfView) && (
              <Route
                exact
                path="/CentroTreinamento/Editar/:id"
                element={<TrainingCenterRegister />}
              />
            )}

            {permissions.Instructor?.canView && (
              <Route exact path="/Instrutor/Listar" element={<InstructorList />} />
            )}

            {permissions.Instructor?.canHandle && (
              <Route exact path="/Instrutor/Cadastrar" element={<InstructorRegister />} />
            )}

            {(permissions.Instructor?.canHandle || permissions.Instructor?.selfView) && (
              <Route exact path="/Instrutor/Editar/:id" element={<InstructorRegister />} />
            )}

            {permissions.Driver?.canView && (
              <Route exact path="/Motorista/Listar" element={<DriverList />} />
            )}

            {permissions.Driver?.canHandle && (
              <Route exact path="/Motorista/Cadastrar" element={<DriverRegister />} />
            )}

            {(permissions.Driver?.canHandle || permissions.Driver?.selfView) && (
              <Route exact path="/Motorista/Editar/:id" element={<DriverRegister />} />
            )}

            {permissions.Vehicle?.canView && (
              <Route exact path="/Veiculo/Listar" element={<VehicleList />} />
            )}

            {permissions.Vehicle?.canHandle && (
              <Route exact path="/Veiculo/Cadastrar" element={<VehicleRegister />} />
            )}

            {(permissions.Vehicle?.canHandle || permissions.Vehicle?.selfView) && (
              <Route exact path="/Veiculo/Editar/:id" element={<VehicleRegister />} />
            )}

            {permissions.Transport?.canView && (
              <Route exact path="/Transporte/Listar" element={<TransportList />} />
            )}

            {permissions.Transport?.canHandle && (
              <Route exact path="/Transporte/Cadastrar" element={<TransportRegister />} />
            )}

            {permissions.Transport?.canHandle && (
              <Route exact path="/Transporte/Editar/:id" element={<TransportRegister />} />
            )}

            {permissions.InstructorManagement?.canView && (
              <Route exact path="/GestaoInstrutores" element={<InstructorManagement />} />
            )}

            {permissions.InstructorManagement?.canView && (
              <Route
                exact
                path="/GestaoInstrutores/Agenda/Instrutor/:id"
                element={<ScheduleInstructor />}
              />
            )}

            {permissions.ScheduleOverview?.canView && (
              <Route exact path="/Agenda/VisaoGeral" element={<ScheduleOverview />} />
            )}

            {permissions.ScheduleScheduling?.canView && (
              <Route exact path="/Agenda/Agendamento" element={<ScheduleScheduling />} />
            )}

            {permissions.ScheduleScheduling?.canView && (
              <Route
                exact
                path="/Agenda/Agendamento/:action/:ctMaxCapacity/:ctName/:ctId"
                element={<ScheduleScheduling />}
              />
            )}

            {permissions.ScheduleScheduling?.canView && (
              <Route
                exact
                path="/Agenda/Agendamento/:action/:taskId"
                element={<ScheduleScheduling />}
              />
            )}

            {permissions.ScheduleTrainingCenter?.canView && (
              <Route exact path="/Agenda/CentroTreinamento" element={<ScheduleTrainingCenter />} />
            )}

            {permissions.ScheduleTrainingCenter?.canView && (
              <Route
                exact
                path="/Agenda/CentroTreinamento/:action/:taskId"
                element={<ScheduleTrainingCenter />}
              />
            )}

            {permissions.ScheduleInstructor?.canView && (
              <Route exact path="/Agenda/Instrutor" element={<ScheduleInstructor />} />
            )}

            {permissions.ScheduleInstructor?.canView && (
              <Route
                exact
                path="/Agenda/Instrutor/:action/:scheduleType/:taskId"
                element={<ScheduleInstructor />}
              />
            )}

            {permissions.ScheduleDriver?.canView && (
              <Route exact path="/Agenda/Motorista" element={<ScheduleDriver />} />
            )}

            {permissions.ScheduleDriver?.canView && (
              <Route
                exact
                path="/Agenda/Motorista/:action/:scheduleType/:taskId"
                element={<ScheduleDriver />}
              />
            )}

            {permissions.Billing?.canView && <Route path="/Faturamento" element={<Billing />} />}

            {permissions.TrainingList?.canView && (
              <Route exact path="Treinamentos/Listar" element={<TaskListView />} />
            )}

            {permissions.Certificates?.canView && (
              <Route exact path="/Certificados/Listar" element={<CertificateView />} />
            )}

            {permissions.Product?.canView && (
              <Route exact path="/Produtos/Listar" element={<ProductList />} />
            )}

            {permissions.Product?.canHandle && (
              <Route exact path="/Produtos/Editar/:id" element={<ProductRegister />} />
            )}

            {permissions.Company?.canView && (
              <Route exact path="/Empresas/Listar" element={<CompanyList />} />
            )}

            {permissions.Company?.canView && (
              <Route exact path="/Empresas/Cadastrar" element={<CompanyRegister />} />
            )}

            {permissions.Company?.canView && (
              <Route exact path="/Empresas/Editar/:id" element={<CompanyRegister />} />
            )}

            {permissions.ReasonNoBilling?.canView && (
              <Route exact path="/MotivoNaoFaturamento/Listar" element={<ReasonNoBillingList />} />
            )}

            {permissions.ReasonNoBilling?.canHandle && (
              <Route
                exact
                path="/MotivoNaoFaturamento/Cadastrar"
                element={<ReasonNoBillingRegister />}
              />
            )}

            {permissions.ReasonNoBilling?.canHandle && (
              <Route
                exact
                path="/MotivoNaoFaturamento/Editar/:id"
                element={<ReasonNoBillingRegister />}
              />
            )}

            {permissions.DenyTaskReason?.canView && (
              <Route exact path="/MotivoDescarte/Listar" element={<DenyTaskReasonList />} />
            )}

            {permissions.DenyTaskReason?.canHandle && (
              <Route exact path="/MotivoDescarte/Cadastrar" element={<DenyTaskReasonRegister />} />
            )}

            {permissions.DenyTaskReason?.canHandle && (
              <Route exact path="/MotivoDescarte/Editar/:id" element={<DenyTaskReasonRegister />} />
            )}

            {permissions.InvoiceIssuer?.canView && (
              <Route exact path="/EmissorNotaFiscal/Listar" element={<InvoiceIssuerList />} />
            )}

            {permissions.InvoiceIssuer?.canHandle && (
              <Route
                exact
                path="/EmissorNotaFiscal/Cadastrar"
                element={<InvoiceIssuerRegister />}
              />
            )}

            {permissions.InvoiceIssuer?.canHandle && (
              <Route
                exact
                path="/EmissorNotaFiscal/Editar/:id"
                element={<InvoiceIssuerRegister />}
              />
            )}

            {permissions.VehicleType?.canView && (
              <Route exact path="/TipoVeiculo/Listar" element={<VehicleTypeList />} />
            )}

            {permissions.VehicleType?.canHandle && (
              <Route exact path="/TipoVeiculo/Cadastrar" element={<VehicleTypeRegister />} />
            )}

            {permissions.VehicleType?.canHandle && (
              <Route exact path="/TipoVeiculo/Editar/:id" element={<VehicleTypeRegister />} />
            )}

            {permissions.DocumentType?.canView && (
              <Route exact path="/TipoDocumento/Listar" element={<DocumentTypeList />} />
            )}

            {permissions.DocumentType?.canHandle && (
              <Route exact path="/TipoDocumento/Cadastrar" element={<DocumentTypeRegister />} />
            )}

            {permissions.DocumentType?.canHandle && (
              <Route exact path="/TipoDocumento/Editar/:id" element={<DocumentTypeRegister />} />
            )}

            {permissions.OccurrenceType?.canView && (
              <Route exact path="/TipoOcorrencia/Listar" element={<OccurrenceTypeList />} />
            )}

            {permissions.OccurrenceType?.canHandle && (
              <Route exact path="/TipoOcorrencia/Cadastrar" element={<OccurrenceTypeRegister />} />
            )}

            {permissions.OccurrenceType?.canHandle && (
              <Route exact path="/TipoOcorrencia/Editar/:id" element={<OccurrenceTypeRegister />} />
            )}

            {permissions.Occurrence?.canView && (
              <Route exact path="/GestaoOcorrencia" element={<OccurrenceManagementView />} />
            )}

            {permissions.Occurrence?.canView && (
              <Route exact path="/Ocorrencia/Listar" element={<OccurrenceList />} />
            )}

            {permissions.Occurrence?.canHandle && (
              <Route exact path="/Ocorrencia/Cadastrar" element={<OccurrenceRegister />} />
            )}

            {permissions.Occurrence?.canHandle && (
              <Route exact path="/Ocorrencia/Editar/:id" element={<OccurrenceRegister />} />
            )}

            <Route path="*" element={<Home />} />
          </Route>
        )}
      </Routes>
    </BrowserRouter>
  );
}
